import { Container } from '@design-system/container';
import { Skeleton } from '@design-system/skeleton';
import { ScreenRecognitionContext } from '@phx-husky/screen-recognition';
import React, { FC, useContext } from 'react';

import { SearchResultSkeletonProps } from '../models';

const skeletons = {
  mobile: {
    tabs: (
      <>
        <Skeleton width={102} height={54} />
        <Skeleton width={102} height={54} />
        <Skeleton width={102} height={54} />
      </>
    ),
    product: (
      <>
        <Skeleton width={106} height={158} />
        <Skeleton
          width={52}
          height={13}
          className="search-result-skeleton__product-title"
        />
        <Skeleton
          width={133}
          height={26}
          className="search-result-skeleton__product-description"
        />
        <Skeleton width={158} height={20} />
        <Skeleton width={135} height={20} />
        <Skeleton width={52} height={20} />
      </>
    ),
    article: (
      <>
        <Skeleton width={171} height={28} />
        <Skeleton width={287} height={20} />
        <Skeleton width={240} height={20} />
      </>
    ),
  },
  desktop: {
    tabs: (
      <>
        <Skeleton width={122} height={30} />
        <Skeleton width={122} height={30} />
        <Skeleton width={122} height={30} />
      </>
    ),
    product: (
      <>
        <Skeleton width={133} height={185} />
        <Skeleton
          width={75}
          height={13}
          className="search-result-skeleton__product-title"
        />
        <Skeleton width={133} height={30} />
        <Skeleton
          width={206}
          height={16}
          className="search-result-skeleton__product-description"
        />
        <Skeleton width={108} height={16} />
      </>
    ),
    article: (
      <>
        <Skeleton width="25%" height={30} />
        <Skeleton width="35%" height={15} />
      </>
    ),
  },
};

export const SearchResultSkeleton: FC<SearchResultSkeletonProps> = ({
  initialVisibleItems,
}) => {
  const skeletonArray = Array.from({ length: initialVisibleItems });
  const { isMobile } = useContext(ScreenRecognitionContext);
  const mode = isMobile ? 'mobile' : 'desktop';

  return (
    <Container className="search-result-skeleton" maxWidth="max-grid">
      <div className="search-result-skeleton__tabs">{skeletons[mode].tabs}</div>
      <div className="search-result-skeleton__products">
        {skeletonArray.map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div className="search-result-skeleton__product" key={index}>
            {skeletons[mode].product}
          </div>
        ))}
      </div>
      <Skeleton
        width={165}
        height={42}
        className="search-result-skeleton__button"
      />
      <div className="search-result-skeleton__articles">
        {skeletonArray.map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div className="search-result-skeleton__article" key={index}>
            {skeletons[mode].article}
          </div>
        ))}
      </div>
      <Skeleton
        width={165}
        height={42}
        className="search-result-skeleton__button"
      />
    </Container>
  );
};

export default SearchResultSkeleton;
